<div class="dashboard-content" style="padding: 120px 40px 50px">
  <div class="user-profile-screen">
    <div class="user-profile-card">
      <div class="profile-row">
        <div class="profile" [class.clickable]="hasCustomAvatar"
          (click)="hasCustomAvatar && openImageModal(avatarSrc)">
          <img *ngIf="hasCustomAvatar" [src]="avatarSrc" alt="avatar" class="profile-picture" />
          <span *ngIf="!hasCustomAvatar" class="avatar-initial" aria-hidden="true">{{ userInitial }}</span>
          <div class="view-icon" *ngIf="hasCustomAvatar">
            <i class="fa-solid fa-expand"></i>
          </div>
        </div>
        <div class="detail">
          <h2>
            {{ userName }}
          </h2>
          <p>
            {{ userEmail }}
          </p>
          <p *ngIf="userPhone">
            <i class="fa-solid fa-phone" style="margin-right: 6px; font-size: 12px;"></i>{{ userPhone }}
          </p>
        </div>
      </div>
      <div class="company-name-row">
        <h1>
          {{ displayBusinessName }}
        </h1>
        <a class="edit-btn" role="button" tabindex="0" (click)="openEditDrawer()"
          (keydown.enter)="openEditDrawer()" style="cursor: pointer">
          <span>{{ 'common.edit' | translate }}</span>
          <i class="fa-solid fa-pen"></i>
        </a>
      </div>
    </div>
    <input class="d-none" #fileInput accept=".png,.jpg,.jpeg" (change)="onFileSelected($event)" type="file" />
    <div class="row">
      <div class="col-lg-12">
        <div class="pb-4 h-100">
          <h4 class="card-heading">{{ 'profile-page.business-info' | translate }}</h4>
          <div class="company-info-card">
            <div class="form-group">
              <label class="form-label">{{ 'profile-page.business-desc' | translate }}</label>
              <textarea rows="10" class="form-control" [placeholder]="'profile-page.business-desc' | translate"
                [value]="originalBusinessDescription" disabled></textarea>
            </div>
            <div class="form-group" style="margin-top: 16px;">
              <label class="form-label">{{ 'profile-page.business-sector' | translate }}</label>
              <input
                type="text"
                class="form-control"
                [value]="businessSectorDisplay"
                [placeholder]="'profile-page.sector-placeholder' | translate"
                readonly />
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="pb-4 h-100">
          <h4 class="card-heading">{{ 'profile-page.change-password' | translate }}</h4>
          <div class="company-info-card h-100">
            <form [formGroup]="resetPasswordForm">
              <!-- Existing Password -->
              <div class="form-group">
                <label class="form-label">{{ 'profile-page.existing-password' | translate }}</label>
                <div class="password-wrapper">
                  <input [type]="showOldPassword ? 'text' : 'password'" class="form-control"
                    [placeholder]="'profile-page.enter-password' | translate" [(ngModel)]="existingPasswordValue"
                    [ngModelOptions]="{standalone: true}" [disabled]="isExistingPasswordVerified" />
                  <span class="toggle-eye" (click)="showOldPassword = !showOldPassword">
                    <i [class]="showOldPassword ? 'fa -solid fa-eye' : 'fa -solid fa-eye-slash'"></i>
                  </span>
                </div>
              </div>

              <!-- Verify Button (only show if not verified yet) -->
              <button type="button" class="btn btn-dark-rounded mb-3" *ngIf="!isExistingPasswordVerified"
                (click)="verifyExistingPassword()" [disabled]="isVerifyingPassword">
                {{ isVerifyingPassword ? ('profile-page.verifying' | translate) : ('profile-page.verify-password' | translate) }}
              </button>

              <!-- New Password (only show after existing password is verified) -->
              <div class="form-group" *ngIf="isExistingPasswordVerified">
                <label class="form-label">{{ 'profile-page.new-password' | translate }}</label>
                <div class="password-wrapper">
                  <input [type]="showNewPassword ? 'text' : 'password'" class="form-control"
                    [placeholder]="'profile-page.new-password-placeholder' | translate" formControlName="new_password"
                    (keydown.space)="$event.preventDefault()" (input)="onPasswordInput()" />
                  <span class="toggle-eye" (click)="showNewPassword = !showNewPassword">
                    <i [class]="showNewPassword ? 'fa -solid fa-eye' : 'fa -solid fa-eye-slash'"></i>
                  </span>
                </div>
                <small class="text-danger" *ngIf="isNewPasswordSameAsOld">
                  {{ 'profile-page.new-password-same' | translate }}
                </small>
              </div>

              <!-- Confirm New Password (only show after existing password is verified) -->
              <div class="form-group" *ngIf="isExistingPasswordVerified">
                <label class="form-label">{{ 'profile-page.confirm-new-password' | translate }}</label>
                <div class="password-wrapper">
                  <input [type]="showConfirmPassword ? 'text' : 'password'" class="form-control"
                    [placeholder]="'profile-page.repeat-password-placeholder' | translate" formControlName="confirmPassword"
                    (keydown.space)="$event.preventDefault()" (input)="stripPasswordSpaces('confirmPassword')" />
                  <span class="toggle-eye" (click)="showConfirmPassword = !showConfirmPassword">
                    <i [class]="showConfirmPassword ? 'fa -solid fa-eye' : 'fa -solid fa-eye-slash'"></i>
                  </span>
                </div>
                <small class="text-danger"
                  *ngIf="resetPasswordForm.get('confirmPassword')?.touched && resetPasswordForm.errors?.['passwordsMismatch']">
                  {{ 'profile-page.passwords-no-match' | translate }}
                </small>
              </div>

              <!-- Password validation (only show after existing password is verified) -->
              <div class="password-must-contain" *ngIf="isExistingPasswordVerified">
                <h4>
                  {{ 'profile-page.password-must-contain' | translate }}
                </h4>
                <div class="form-check custom-checkbox">
                  <input class="form-check-input" type="checkbox" [checked]="passwordStrength.minLength" disabled>
                  <label class="form-check-label">
                    {{ 'profile-page.min-8-chars' | translate }}
                  </label>
                </div>
                <div class="form-check custom-checkbox">
                  <input class="form-check-input" type="checkbox" [checked]="passwordStrength.uppercase" disabled>
                  <label class="form-check-label">
                    {{ 'profile-page.one-upper' | translate }}
                  </label>
                </div>
                <div class="form-check custom-checkbox">
                  <input class="form-check-input" type="checkbox" [checked]="passwordStrength.lowercase" disabled>
                  <label class="form-check-label">
                    {{ 'profile-page.one-lower' | translate }}
                  </label>
                </div>
                <div class="form-check custom-checkbox">
                  <input class="form-check-input" type="checkbox" [checked]="passwordStrength.number" disabled>
                  <label class="form-check-label">
                    {{ 'profile-page.one-number' | translate }}
                  </label>
                </div>
                <div class="form-check custom-checkbox">
                  <input class="form-check-input" type="checkbox" [checked]="passwordStrength.specialChar" disabled>
                  <label class="form-check-label">
                    {{ 'profile-page.one-special' | translate }}
                  </label>
                </div>
              </div>

              <!-- Change Password Button (only show after existing password is verified) -->
              <button type="button" class="btn btn-dark-rounded" *ngIf="isExistingPasswordVerified"
                (click)="onResetPassword()" [disabled]="!canSubmit()">
                {{ 'profile-page.change-password' | translate }}
              </button>
            </form>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="pb-4 h-100">
          <h4 class="card-heading">{{ 'profile-page.security-info' | translate }}</h4>
          <div class="security-information-card h-100">
            <img src="../../../../assets/images/logo-dark.svg" class="logo clickable-logo" alt=""
              (click)="openImageModal('../../../../assets/images/logo-dark.svg')">
            <p>
              {{ 'profile.cn_supprt_detail' | translate }}
            </p>
            <div class="social-icons">
              <a href="https://www.facebook.com/share/18E8BjPtw8/" target="_blank" rel="noopener noreferrer">
                <img src="../../../../assets/images/s1.svg" alt="Facebook">
              </a>
              <a href="https://www.instagram.com/luqta.eg?igsh=azF5NHh1azAwMzB6" target="_blank"
                rel="noopener noreferrer">
                <img src="../../../../assets/images/s5.svg" alt="Instagram">
              </a>
              <a href="https://wa.me/15558387285" target="_blank" rel="noopener noreferrer">
                <img src="../../../../assets/images/s4.svg" alt="WhatsApp">
              </a>
              <a href="https://www.linkedin.com/company/luqta-io" target="_blank" rel="noopener noreferrer">
                <img src="../../../../assets/images/s3.svg" alt="LinkedIn">
              </a>
              <a href="https://x.com/Luqtaegypt" target="_blank" rel="noopener noreferrer">
                <img src="../../../../assets/images/t-x.svg" alt="X (Twitter)">
              </a>
              <a href="mailto:support@luqta.io" class="btn btn-email">
                <img src="../../../../assets/images/s6.svg" alt="Email">
                <span>
                  {{ 'common.email' | translate }}
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--  <section class="profile-page contests-container">
    <br>
    <div class="contests-content">
      <nav class="nav-content">
        <div class="nav nav-tabs mb-3 d-flex" id="profileTab" role="tablist">
          <button class="nav-link active" id="company-tab" data-bs-toggle="tab" data-bs-target="#company" type="button"
            role="tab" aria-controls="company" aria-selected="true">
            {{ "profile.companyTab" | translate }}
          </button>
          <button class="nav-link" id="user-tab" data-bs-toggle="tab" data-bs-target="#user" type="button" role="tab"
            aria-controls="user" aria-selected="false">
            {{ "profile.userTab" | translate }}
          </button>
        </div>
      </nav>
      <div class="form-start">
        <form [formGroup]="profileForm" (ngSubmit)="onSubmit()" class="row justify-content-start">
          <div class="col-xl-6 bg-white rounded" style="padding-right: 20px">
            <div class="tab-content" id="profileTabContent">
              <div class="tab-pane fade show active" id="company" role="tabpanel" aria-labelledby="company-tab">
                <h3 class="upload-logo">{{ "profile.upload" | translate }}</h3>
                <div *ngIf="imageSrc" class="profile-container img-container" (click)="triggerFileInput()">
                  <img [src]="imageSrc" alt="" class="profile-picture border" />
                  <span class="profile-upload">
                    <i class="fa-solid fa-camera text-md text-white"></i>
                    <input class="d-hidden" #fileInput accept=".png, .jpg, .jpeg" (change)="onFileSelected($event)"
                      type="file" />
                  </span>
                </div>
                <div *ngIf="imageSrc" class="update-btn mt-2">
                  <button type="button" class="btn btn-remove btn-sm" (click)="removeImage()">
                    {{ "profile.remove" | translate }}
                  </button>
                </div>
                <div *ngIf="!imageSrc"
                  class="profile-data text-center align-items-center d-flex flex-column position-relative"
                  (click)="triggerFileInput()">
                  <div class="profile-container">
                    <img src="../../../../assets/images/profile_image.png" alt="avatar" class="profile-picture" />
                    <span class="profile-upload">
                      <i class="fa-solid fa-camera text-md text-white"></i>
                      <input class="d-hidden" #fileInput accept=".png, .jpg, .jpeg" (change)="onFileSelected($event)"
                        type="file" />
                    </span>
                  </div>
                  <div class="image-details">
                    <p><b>Browse photo</b> or drop here</p>
                    <p class="image-size">{{ "profile.size" | translate }}</p>
                  </div>
                </div>
                <div class="form-value" style="margin-top: 16px">
                  <div class="mb-3 position-relative">
                    <label for="companyName" class="form-label">{{ "profile.c_name" | translate }}</label>
                    <input type="text" id="companyName" class="form-control" formControlName="name"
                      placeholder="Enter your business name" />
                    <div class="px-1 w-100 position-absolute mt-1">
                      <small class="error text-danger"
                        *ngIf="profileForm.controls['name'].invalid && profileForm.controls['name'].touched">
                        <span class="text-left" *ngIf="profileForm.controls['name'].errors?.['required']">
                          Company name is required
                        </span>
                      </small>
                    </div>
                  </div>
                  <div class="mb-3 position-relative mt-5">
                    <label for="aboutCompany" class="form-label">{{ "profile.a_company" | translate }} </label>
                    <textarea id="aboutCompany" rows="3" class="form-control textarea" formControlName="address"
                      [placeholder]="'profile.description' | translate"></textarea>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="text-center">
                    <button type="submit" class="btn btn-save w-100 mt-0">Update</button>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" id="user" role="tabpanel" aria-labelledby="user-tab">
                <form [formGroup]="resetPasswordForm" (ngSubmit)="onResetPassword()">
                  <div class="add-user-data">
                    <div class="row">
                      <div class="col-lg-12">
                        <div class="mb-4">
                          <label class="form-label label-user">Update Your Password</label>
                        </div>
                      </div>
                      <div class="col-lg-12">
                        <div class="input-group mb-4 position-relative">
                          <input [type]="resetPassword.old ? 'text' : 'password'" class="form-control"
                            placeholder="Current Password" formControlName="oldPassword" />
                          <button class="btn-password" type="button" (click)="toggleResetPasswordVisibility('old')">
                            <i [class.fa-eye]="resetPassword.old" [class.fa-eye-slash]="!resetPassword.old"
                              class="fa -solid"></i>
                          </button>
                          <div class="px-1 w-100 position-absolute mt-5">
                            <small class="error text-danger"
                              *ngIf="resetPasswordForm.get('oldPassword')?.touched && resetPasswordForm.get('oldPassword')?.errors?.['required']">
                              Current password is required
                            </small>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-12">
                        <div class="input-group mb-4 position-relative">
                          <input [type]="resetPassword.new ? 'text' : 'password'" class="form-control"
                            placeholder="New Password" formControlName="new_password" (input)="onPasswordInput()" />
                          <button class="btn-password" type="button" (click)="toggleResetPasswordVisibility('new')">
                            <i [class.fa-eye]="resetPassword.new" [class.fa-eye-slash]="!resetPassword.new"
                              class="fa -solid"></i>
                          </button>
                        </div>
                      </div>
                      <div class="col-lg-12">
                        <div class="input-group mb-4 position-relative">
                          <input [type]="resetPassword.confirm ? 'text' : 'password'" class="form-control"
                            placeholder="Confirm New Password" formControlName="confirmPassword" />
                          <button class="btn-password" type="button" (click)="toggleResetPasswordVisibility('confirm')">
                            <i [class.fa-eye]="resetPassword.confirm" [class.fa-eye-slash]="!resetPassword.confirm"
                              class="fa -solid"></i>
                          </button>
                          <div class="px-1 w-100 position-absolute mt-5">
                            <small class="error text-danger"
                              *ngIf="resetPasswordForm.get('confirmPassword')?.touched && resetPasswordForm.errors?.['passwordsMismatch']">
                              Confirm Password does not match
                            </small>
                          </div>
                        </div>
                      </div>
                      <div class="row password-strength mt-4" style="margin-bottom: 24px;">
                        <div class="password-check col-6 d-flex align-items-center mb-2"
                          style="transition: all 0.3s ease;">
                          <i class="fa-solid"
                            [class]="passwordStrength.lowercase ? 'fa-circle-check' : 'fa-circle-check'"
                            [style.color]="passwordStrength.lowercase ? '#2E3B55' : '#ABB1BB'"
                            style="margin-right: 8px; font-size: 16px; transition: color 0.3s ease;"></i>
                          <span [style.color]="passwordStrength.lowercase ? '#2E3B55' : '#ABB1BB'"
                            [style.font-weight]="passwordStrength.lowercase ? '500' : 'normal'"
                            style="font-size: 14px; transition: all 0.3s ease;">
                            One lowercase character
                          </span>
                        </div>
                        <div class="password-check col-6 d-flex align-items-center mb-2"
                          style="transition: all 0.3s ease;">
                          <i class="fa-solid"
                            [class]="passwordStrength.uppercase ? 'fa-circle-check' : 'fa-circle-check'"
                            [style.color]="passwordStrength.uppercase ? '#2E3B55' : '#ABB1BB'"
                            style="margin-right: 8px; font-size: 16px; transition: color 0.3s ease;"></i>
                          <span [style.color]="passwordStrength.uppercase ? '#2E3B55' : '#ABB1BB'"
                            [style.font-weight]="passwordStrength.uppercase ? '500' : 'normal'"
                            style="font-size: 14px; transition: all 0.3s ease;">
                            One uppercase character
                          </span>
                        </div>
                        <div class="password-check col-6 d-flex align-items-center mb-2"
                          style="transition: all 0.3s ease;">
                          <i class="fa-solid" [class]="passwordStrength.number ? 'fa-circle-check' : 'fa-circle-check'"
                            [style.color]="passwordStrength.number ? '#2E3B55' : '#ABB1BB'"
                            style="margin-right: 8px; font-size: 16px; transition: color 0.3s ease;"></i>
                          <span [style.color]="passwordStrength.number ? '#2E3B55' : '#ABB1BB'"
                            [style.font-weight]="passwordStrength.number ? '500' : 'normal'"
                            style="font-size: 14px; transition: all 0.3s ease;">
                            One number
                          </span>
                        </div>
                        <div class="password-check col-6 d-flex align-items-center mb-2"
                          style="transition: all 0.3s ease;">
                          <i class="fa-solid"
                            [class]="passwordStrength.specialChar ? 'fa-circle-check' : 'fa-circle-check'"
                            [style.color]="passwordStrength.specialChar ? '#2E3B55' : '#ABB1BB'"
                            style="margin-right: 8px; font-size: 16px; transition: color 0.3s ease;"></i>
                          <span [style.color]="passwordStrength.specialChar ? '#2E3B55' : '#ABB1BB'"
                            [style.font-weight]="passwordStrength.specialChar ? '500' : 'normal'"
                            style="font-size: 14px; transition: all 0.3s ease;">
                            One special character
                          </span>
                        </div>
                        <div class="password-check col-6 d-flex align-items-center mb-2"
                          style="transition: all 0.3s ease;">
                          <i class="fa-solid"
                            [class]="passwordStrength.minLength ? 'fa-circle-check' : 'fa-circle-check'"
                            [style.color]="passwordStrength.minLength ? '#2E3B55' : '#ABB1BB'"
                            style="margin-right: 8px; font-size: 16px; transition: color 0.3s ease;"></i>
                          <span [style.color]="passwordStrength.minLength ? '#2E3B55' : '#ABB1BB'"
                            [style.font-weight]="passwordStrength.minLength ? '500' : 'normal'"
                            style="font-size: 14px; transition: all 0.3s ease;">
                            8 characters minimum
                          </span>
                        </div>
                      </div>
                      <div class="col-lg-12">
                        <div class="text-center">
                          <button type="submit" [disabled]="!canSubmit()" class="btn btn-save w-100 mt-0"
                            [style.opacity]="canSubmit() ? '1' : '0.6'"
                            [style.cursor]="canSubmit() ? 'pointer' : 'not-allowed'">
                            Save Changes
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="col-xl-6 contact-data" style="padding-left: 20px">
            <div class="Contact-support position-relative">
              <h1 class="support-heading">{{ "profile.cn_supprt" | translate }}</h1>
              <p class="lorem-para">{{ "profile.cn_supprt_detail" | translate }}</p>
              <div class="bottom d-flex justify-content-center align-items-center">
                <a class="btn-win px-3">
                  <div class="button-data">
                    <h6 class="email-text">{{ "profile.email" | translate }}</h6>
                    <p class="email-para">&#64;gmail.com</p>
                  </div>
                </a>
                <a class="btn-win px-3">
                  <div class="button-data">
                    <h6 class="email-text">{{ "profile.whatsapp" | translate }}</h6>
                    <p class="email-para">+1 344346293</p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </section>

  <!-- WhatsApp Campaign Companion connection management -->
  <section class="companion-section" *ngIf="hasCompanionAccess">
    <app-companion-card></app-companion-card>
  </section>

  <section>
    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"
      #exampleModal>
      <div class="modal-dialog modal-dialog-centered profile-modal">
        <div class="modal-content text-center">
          <button type="button" class="btn-close btn-close-modal position-absolute end-0 top-0 m-3"
            data-bs-dismiss="modal" aria-label="Close"></button>
          <div class="modal-body">
            <div class="mb-3">
              <span class="d-inline-flex justify-content-center align-items-center rounded-circle">
                <svg xmlns="http://www.w3.org/2000/svg" width="152" height="152" viewBox="0 0 152 152" fill="none">
                  <rect width="152" height="152" rx="76" fill="#F1E7D1" fill-opacity="0.4" />
                  <path
                    d="M57.25 78.7777C57.25 78.7777 60.375 80.1666 64.5416 86.4166C64.5416 86.4166 65.1351 85.4149 66.2528 83.8179M86.4166 63.5C81.6427 65.887 76.6497 70.8996 72.6414 75.6298"
                    stroke="#B88917" stroke-width="3.12499" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M67.667 78.7777C67.667 78.7777 70.792 80.1666 74.9586 86.4166C74.9586 86.4166 86.4169 68.7083 96.8336 63.5"
                    stroke="#B88917" stroke-width="3.12499" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </span>
            </div>
            <h5 class="fw-bold">Changes Saved</h5>
            <p class="modal-para">
              Congratulations we received your campaign request successfully.
              Please, Keep an eye on notification after carefully reviewing we let
              you know.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Edit Profile drawer -->
  <nz-drawer [nzVisible]="isEditMode" [nzWidth]="520" [nzTitle]="editProfileTitleTpl"
    [nzPlacement]="isArabic ? 'left' : 'right'" nzWrapClassName="create-user-drawer edit-profile-drawer"
    [nzClosable]="false" [nzBodyStyle]="{'overflow': 'auto'}" (nzOnClose)="cancelProfileEdit()">

    <ng-template #editProfileTitleTpl>
      <div class="d-flex align-items-center gap-2">
        <button type="button" class="ep-back-btn" (click)="cancelProfileEdit()" [attr.aria-label]="'common.cancel' | translate">
          <i class="fa-solid" [class.fa-angle-left]="!isArabic" [class.fa-angle-right]="isArabic"></i>
        </button>
        <h3 class="ep-title">{{ 'profile-page.edit-profile' | translate }}</h3>
      </div>
    </ng-template>

    <ng-container *nzDrawerContent>
      <div class="ep-body">
        <!-- Photo -->
        <div class="ep-photo" [class.is-dragover]="isPhotoDragOver" (dragover)="onPhotoDragOver($event)"
          (dragleave)="isPhotoDragOver = false" (drop)="onPhotoDrop($event)">
          <button type="button" class="ep-avatar" (click)="triggerFileInput()"
            [attr.aria-label]="'profile-page.browse-photo' | translate">
            <img *ngIf="hasCustomAvatar" [src]="avatarSrc" alt="" />
            <span *ngIf="!hasCustomAvatar" class="ep-avatar-initial" aria-hidden="true">{{ userInitial }}</span>
            <span class="ep-avatar-badge" aria-hidden="true"><i class="fa-solid fa-camera"></i></span>
          </button>
          <div class="d-flex align-items-center gap-2">
            <button type="button" class="ep-browse-btn" (click)="triggerFileInput()">
              <i class="fa-solid fa-cloud-arrow-up" aria-hidden="true"></i>
              <span>{{ 'profile-page.browse-photo' | translate }}</span>
            </button>
            <button *ngIf="hasCustomAvatar" type="button" class="btn btn-outline-danger btn-sm" (click)="removeImage()" style="border-radius: 20px; font-size: 12px; padding: 6px 14px;">
              <i class="fa-solid fa-trash-can me-1"></i>
              <span>{{ 'profile.remove' | translate }}</span>
            </button>
          </div>
          <p class="ep-hint">{{ 'profile-page.photo-hint' | translate }}</p>
        </div>

        <!-- Personal Information -->
        <section class="ep-section">
          <h4 class="ep-section-title">
            <i class="fa-solid fa-user" aria-hidden="true"></i>{{ 'profile-page.personal-info' | translate }}
          </h4>
          <div class="form-group">
            <label class="form-label" for="ep-name">{{ 'common.name' | translate }}<span>*</span></label>
            <input id="ep-name" type="text" class="form-control" [(ngModel)]="editableName" #epName="ngModel" required
              maxlength="100" [class.is-invalid]="epName.invalid && epName.touched"
              [placeholder]="'profile-page.name-placeholder' | translate" />
            <small class="text-danger" *ngIf="epName.invalid && epName.touched">
              {{ 'profile-page.name-empty' | translate }}
            </small>
          </div>
          <div class="form-group">
            <label class="form-label" for="ep-email">{{ 'common.email' | translate }}</label>
            <div class="ep-locked">
              <input id="ep-email" type="email" class="form-control" [value]="userEmail" disabled />
              <i class="fa-solid fa-lock" aria-hidden="true"></i>
            </div>
            <small class="ep-help">{{ 'profile-page.email-locked' | translate }}</small>
          </div>
          <div class="form-group mb-0">
            <label class="form-label" for="ep-phone">{{ 'user-management.phone-number' | translate }}</label>
            <div class="country-dropdown2 position-relative" dir="ltr" (focusout)="epPhoneTouched = true">
              <ngx-intl-tel-input
                [cssClass]="'form-control'"
                [enableAutoCountrySelect]="false"
                [enablePlaceholder]="true"
                [searchCountryFlag]="true"
                [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                [selectFirstCountry]="false"
                [selectedCountryISO]="editPhoneCountry"
                [maxLength]="15"
                [phoneValidation]="false"
                [separateDialCode]="true"
                [numberFormat]="PhoneNumberFormat.National"
                inputId="ep-phone"
                name="ep-phone"
                [(ngModel)]="editPhoneInput"
                (ngModelChange)="onEditPhoneChange($event)">
              </ngx-intl-tel-input>
            </div>
            <small class="text-danger" *ngIf="epPhoneTouched && !isEditablePhoneValid">
              {{ 'profile-page.phone-invalid' | translate }}
            </small>
          </div>
        </section>

        <!-- Business Information -->
        <section class="ep-section">
          <h4 class="ep-section-title">
            <i class="fa-solid fa-building" aria-hidden="true"></i>{{ 'profile-page.business-info' | translate }}
          </h4>
          <div class="form-group">
            <label class="form-label" for="ep-business-name">{{ 'profile-page.business-name' | translate }}<span>*</span></label>
            <input id="ep-business-name" type="text" class="form-control" [(ngModel)]="editableBusinessName"
              #epBusinessName="ngModel" required maxlength="100"
              [class.is-invalid]="epBusinessName.invalid && epBusinessName.touched"
              [placeholder]="'profile-page.business-name-placeholder' | translate" />
            <small class="text-danger" *ngIf="epBusinessName.invalid && epBusinessName.touched">
              {{ 'profile-page.business-name-empty' | translate }}
            </small>
          </div>
          <div class="form-group">
            <label class="form-label" for="ep-business-name-arabic">{{ 'profile-page.business-name-arabic' | translate }}</label>
            <input id="ep-business-name-arabic" type="text" class="form-control" dir="rtl" lang="ar"
              [(ngModel)]="editableBusinessNameArabic" maxlength="100"
              aria-describedby="ep-business-name-arabic-help"
              [placeholder]="'profile-page.business-name-arabic-placeholder' | translate" />
            <small id="ep-business-name-arabic-help">{{ 'profile-page.business-name-arabic-help' | translate }}</small>
          </div>
          <div class="form-group">
            <label class="form-label">{{ 'profile-page.business-sector' | translate }}</label>
            <nz-cascader
              #businessSectorCascader
              [nzOptions]="sectorsTree"
              [(ngModel)]="businessSector"
              (ngModelChange)="onSectorChange($event)"
              (nzVisibleChange)="onSectorDropdownVisible($event)"
              [nzMenuStyle]="sectorMenuStyle"
              nzMenuClassName="business-sector-menu"
              [nzPlaceHolder]="'profile-page.sector-placeholder' | translate"
              [nzShowSearch]="true"
              [nzChangeOnSelect]="true"
              [nzMultiple]="true"
              nzExpandTrigger="hover"
              class="form-control-qr category-cascader w-100">
            </nz-cascader>
          </div>
          <div class="form-group mb-0">
            <label class="form-label" for="ep-business-desc">{{ 'profile-page.business-desc' | translate }}</label>
            <textarea id="ep-business-desc" rows="3" class="form-control"
              [placeholder]="'profile-page.desc-placeholder' | translate"
              [(ngModel)]="businessDescription" (ngModelChange)="onCompanyNameChange()"></textarea>
          </div>
        </section>

        <div class="ep-actions">
          <button type="button" class="ep-btn ep-btn-cancel" (click)="cancelProfileEdit()">
            {{ 'common.cancel' | translate }}
          </button>
          <button type="button" class="ep-btn ep-btn-save" (click)="saveProfileChanges()"
            [disabled]="!editableName.trim() || !editableBusinessName.trim() || !isEditablePhoneValid">
            {{ 'common.save-changes' | translate }}
          </button>
        </div>
      </div>
    </ng-container>
  </nz-drawer>

  <!-- Image Modal -->
  <app-image-modal [isVisible]="imageModalVisible" [images]="imageModalImages" [currentIndex]="imageModalCurrentIndex"
    [alt]="'Profile Image'" (closeModal)="closeImageModal()" (indexChange)="onImageIndexChange($event)">
  </app-image-modal>

  <!-- Image Cropper Modal -->
  <nz-modal [(nzVisible)]="cropperModalVisible" nzTitle="Crop Image" [nzWidth]="600" [nzFooter]="cropperFooter"
    (nzOnCancel)="cancelCrop()" nzCentered nzClassName="luqta-custom-modal cropper-modal">
    <ng-container *nzModalContent>
      <div style="max-height: 500px; overflow: auto;">
        <image-cropper [imageChangedEvent]="imageChangedEvent" [imageFile]="droppedImageFile" [maintainAspectRatio]="true" [aspectRatio]="1"
          [resizeToWidth]="600" [cropperStaticWidth]="0" [cropperStaticHeight]="0" [roundCropper]="false" format="png"
          (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded($event)" (cropperReady)="cropperReady()"
          (loadImageFailed)="loadImageFailed()">
        </image-cropper>
      </div>
    </ng-container>
    <ng-template #cropperFooter>
      <button class="btn cropper-cancel-btn" (click)="cancelCrop()">{{ 'common.cancel' | translate }}</button>
      <button class="btn cropper-save-btn" (click)="confirmCrop()">{{ 'profile-page.crop-save' | translate }}</button>
    </ng-template>
  </nz-modal>
</div>
